import { beneficiaryReducer, BeneficiaryState } from '@/store/beneficiary'
import { ISocket, socketIOMiddleware } from '@/store/middleware/socket'
import { IApi } from '@/store/spi/api'
import { configureStore } from '@reduxjs/toolkit/react'
import { feedbackReducer, FeedbackState } from '@/store/feedback.ts'

export const createStore = ({
  api,
  initialState,
  socket,
}: {
  api: IApi
  initialState?: RootState
  socket: ISocket
}) => {
  return configureStore({
    preloadedState: initialState,
    reducer: {
      beneficiary: beneficiaryReducer,
      feedback: feedbackReducer,
    },
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        thunk: {
          extraArgument: { api },
        },
      }).concat([socketIOMiddleware(socket)]),
  })
}

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = {
  beneficiary: BeneficiaryState
  feedback: FeedbackState
}
